import { render, staticRenderFns } from "./text-bars.vue?vue&type=template&id=09a8a5da&scoped=true&"
var script = {}
import style0 from "./text-bars.vue?vue&type=style&index=0&id=09a8a5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a8a5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a8a5da')) {
      api.createRecord('09a8a5da', component.options)
    } else {
      api.reload('09a8a5da', component.options)
    }
    module.hot.accept("./text-bars.vue?vue&type=template&id=09a8a5da&scoped=true&", function () {
      api.rerender('09a8a5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-bars.vue"
export default component.exports